import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const CompletionStep = ({ sessionData, onComplete }) => {
  const [copied, setCopied] = useState(false);
  const sessionUrl = `https://picklelink.app/s/${sessionData?.token || 'abc123xyz'}`;

  const handleCopyLink = () => {
    navigator.clipboard?.writeText(sessionUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleKakaoShare = () => {
    alert('카카오톡 공유 기능이 실행됩니다.');
  };

  const generateAnnouncementText = () => {
    return `🏸 ${sessionData?.title || '제목'}\n\n📅 날짜: ${sessionData?.date || '미정'}\n⏰ 시간: ${sessionData?.startTime || ''} - ${sessionData?.endTime || ''}\n📍 장소: ${sessionData?.venue || '미정'}\n👥 정원: ${sessionData?.maxParticipants || 0}명\n\n💰 참가비: ${sessionData?.pricingModel === 'fixed' ? `회원 ₩${parseInt(sessionData?.memberPrice || 0)?.toLocaleString()}` : '상세 내용 확인'}\n\n🔗 등록 링크:\n${sessionUrl}`;
  };

  const handleCopyAnnouncement = () => {
    navigator.clipboard?.writeText(generateAnnouncementText());
    alert('공지 텍스트가 복사되었습니다!');
  };

  return (
    <div className="space-y-6 md:space-y-8">
      <div className="bg-success/10 border border-success/20 rounded-xl p-6 md:p-8 text-center">
        <div className="w-16 h-16 md:w-20 md:h-20 bg-success rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="CheckCircle" size={40} color="var(--color-success-foreground)" />
        </div>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-2">
          생성되었습니다!
        </h2>
        <p className="text-sm md:text-base caption text-muted-foreground">
          이제 참가자들과 링크를 공유하세요.
        </p>
      </div>
      <div className="bg-card border border-border rounded-xl p-6 md:p-8 space-y-6">
        <div className="space-y-4">
          <h3 className="text-xl font-heading font-semibold text-foreground flex items-center gap-2">
            <Icon name="Link" size={24} className="text-primary" />
            링크
          </h3>

          <div className="flex gap-2">
            <Input
              type="text"
              value={sessionUrl}
              readOnly
              className="flex-1 bg-muted/30"
            />
            <Button
              variant={copied ? 'success' : 'default'}
              iconName={copied ? 'Check' : 'Copy'}
              onClick={handleCopyLink}
            >
              {copied ? '복사됨' : '복사'}
            </Button>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              variant="outline"
              iconName="MessageCircle"
              iconPosition="left"
              onClick={handleKakaoShare}
              fullWidth
            >
              카카오톡으로 공유
            </Button>

            <Button
              variant="outline"
              iconName="Share2"
              iconPosition="left"
              onClick={handleCopyLink}
              fullWidth
            >
              링크 공유
            </Button>
          </div>
        </div>

        <div className="pt-6 border-t border-border space-y-4">
          <h3 className="text-xl font-heading font-semibold text-foreground flex items-center gap-2">
            <Icon name="FileText" size={24} className="text-primary" />
            공지 텍스트
          </h3>

          <div className="bg-muted rounded-md p-4 font-mono text-sm whitespace-pre-wrap">
            {generateAnnouncementText()}
          </div>

          <Button
            variant="outline"
            iconName="Copy"
            iconPosition="left"
            onClick={handleCopyAnnouncement}
            fullWidth
          >
            공지 텍스트 복사
          </Button>
        </div>
      </div>
      <div className="bg-card border border-border rounded-xl p-6 md:p-8 space-y-4">
        <h3 className="text-xl font-heading font-semibold text-foreground flex items-center gap-2">
          <Icon name="Info" size={24} className="text-primary" />
          다음 단계
        </h3>

        <div className="space-y-3">
          <div className="flex items-start gap-3 p-4 bg-muted rounded-md">
            <div className="w-8 h-8 bg-primary text-primary-foreground rounded-full flex items-center justify-center flex-shrink-0 font-heading font-bold">
              1
            </div>
            <div className="flex-1">
              <h4 className="font-heading font-medium text-foreground mb-1">
                링크 공유
              </h4>
              <p className="text-sm caption text-muted-foreground">
                카카오톡 오픈채팅방이나 단체 채팅방에 링크를 공유하세요.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3 p-4 bg-muted rounded-md">
            <div className="w-8 h-8 bg-primary text-primary-foreground rounded-full flex items-center justify-center flex-shrink-0 font-heading font-bold">
              2
            </div>
            <div className="flex-1">
              <h4 className="font-heading font-medium text-foreground mb-1">
                참가자 관리
              </h4>
              <p className="text-sm caption text-muted-foreground">
                관리 페이지에서 참가 신청을 확인하고 승인하세요.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3 p-4 bg-muted rounded-md">
            <div className="w-8 h-8 bg-primary text-primary-foreground rounded-full flex items-center justify-center flex-shrink-0 font-heading font-bold">
              3
            </div>
            <div className="flex-1">
              <h4 className="font-heading font-medium text-foreground mb-1">
                결제 확인
              </h4>
              <p className="text-sm caption text-muted-foreground">
                참가자들의 입금 내역을 확인하고 결제 상태를 업데이트하세요.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3 p-4 bg-muted rounded-md">
            <div className="w-8 h-8 bg-primary text-primary-foreground rounded-full flex items-center justify-center flex-shrink-0 font-heading font-bold">
              4
            </div>
            <div className="flex-1">
              <h4 className="font-heading font-medium text-foreground mb-1">
                대진표 생성
              </h4>
              <p className="text-sm caption text-muted-foreground">
                등록 마감 후 대진표를 생성하고 참가자들에게 공유하세요.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          variant="outline"
          iconName="ArrowLeft"
          iconPosition="left"
          onClick={() => window.location.href = '/session-list-dashboard/invite'}
          fullWidth
        >
          목록으로
        </Button>

        <Button
          variant="default"
          iconName="Settings"
          iconPosition="left"
          onClick={() => window.location.href = '/session-list-dashboard/invite'}
          fullWidth
        >
          완료
        </Button>
      </div>
    </div>
  );
};

export default CompletionStep;